var _defs, _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_148",
    "data-name": "Group 148",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.546,
    height: 112.802,
    viewBox: "0 0 87.546 112.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(0)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M406.263,473.18,362.49,500.118s0,55.562,43.773,85.864c43.773-30.307,43.773-85.864,43.773-85.864Z",
    transform: "translate(-362.49 -473.18)",
    fill: "url(#linear-gradient)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M409.288,480.23,368,505.652s0,52.432,41.311,81.029c41.311-28.6,41.311-81.029,41.311-81.029Z",
    transform: "translate(-365.515 -477.05)",
    fill: "#0e48c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M460.248,480.23l-.708.451V586.213l.708.5c41.311-28.6,41.311-81.029,41.311-81.029Z",
    transform: "translate(-415.771 -477.05)",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M415.08,493.85l-36.53,22.486s0,46.38,36.53,71.68c36.53-25.3,36.53-71.68,36.53-71.68Z",
    transform: "translate(-371.307 -484.528)",
    fill: "#0e48c6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M459.55,494.24v94.149c36.53-25.3,36.53-71.68,36.53-71.68Z",
    transform: "translate(-415.777 -484.742)",
    opacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerm);
export default __webpack_public_path__ + "static/media/Term.6f765b2f60940c1bce433912b6f2f24d.svg";
export { ForwardRef as ReactComponent };